﻿<div class="col-xs-12">
    <div>
        <div [attr.id]="element">
            <ng-content></ng-content>
        </div>
    </div>
</div>